import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class Influencers extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='Influencers'>
      <div className='influencerWrapper'>
  			<div className='influencersTitle'>Influencer Jewelry Box</div>
        
        <div className={'influencerRow copyLeft'}>
          <div className={'influencerImg influencerBkb'}></div>
          <div className='influencerCopy'>
            <div className='icWrapper'>
              <div className='icTitle'>Brighton Keller Butler</div>
              <div className='icHandle' onClick={() => this.openNew('https://www.instagram.com/brightonbutler/')}>@brightonbutler</div>
              <div className='icLink' onClick={() => this.internalNav('jewelry-box/brightonbutler')}>See Brighton's Picks<span className='icLinkArrow'></span></div>
            </div>
          </div>
        </div>

        <div className={'influencerRow copyRight'}>
          <div className={'influencerImg influencerCw'}></div>
          <div className='influencerCopy'>
            <div className='icWrapper'>
              <div className='icTitle'>Courtney Williams</div>
              <div className='icHandle' onClick={() => this.openNew('https://www.instagram.com/courtnwilliams/')}>@courtnwilliams</div>
              <div className='icLink' onClick={() => this.internalNav('jewelry-box/courtnwilliams')}>See Courtney's Picks<span className='icLinkArrow'></span></div>
            </div>
          </div>
        </div>

        <div className={'influencerRow copyLeft'}>
          <div className={'influencerImg influencerJp'}></div>
          <div className='influencerCopy'>
            <div className='icWrapper'>
              <div className='icTitle'>Jennifer Palpallotoc Perrault</div>
              <div className='icHandle' onClick={() => this.openNew('https://www.instagram.com/hauteofftherack/')}>@hauteofftherack</div>
              <div className='icLink' onClick={() => this.internalNav('jewelry-box/hauteofftherack')}>See Jennifer's Picks<span className='icLinkArrow'></span></div>
            </div>
          </div>
        </div>

        <div className={'influencerRow copyRight'}>
          <div className={'influencerImg influencerAa'}></div>
          <div className='influencerCopy'>
            <div className='icWrapper'>
              <div className='icTitle'>Aubrey Alley</div>
              <div className='icHandle' onClick={() => this.openNew('https://www.instagram.com/aubrey.alley/')}>@aubrey.alley</div>
              <div className='icLink' onClick={() => this.internalNav('jewelry-box/aubreyalley')}>See Aubrey's Picks<span className='icLinkArrow'></span></div>
            </div>
          </div>
        </div>

        <div className={'influencerRow copyLeft'}>
          <div className={'influencerImg influencerMr'}></div>
          <div className='influencerCopy'>
            <div className='icWrapper'>
              <div className='icTitle'>Megan Runion</div>
              <div className='icHandle' onClick={() => this.openNew('https://www.instagram.com/meganrunionmcr/')}>@meganrunionmcr</div>
              <div className='icLink' onClick={() => this.internalNav('jewelry-box/meganrunionmcr')}>See Megan's Picks<span className='icLinkArrow'></span></div>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default Influencers;

function mapStateToProps(state) {
  return {

  };
}

export const InfluencersContainer = connect(
  mapStateToProps,
  allActionCreators
)(Influencers);


// WEBPACK FOOTER //
// ./src/components/views/influencers/Influencers.jsx